import { formatDate } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { useForm } from '../_load/FormLoader'
import { useFormReplies } from '../_load/FormRepliesLoader'
import {
  useOpenEditServiceOrderModal,
  useOpenFormReplyModal,
  useOpenFormReplyServiceOrdersModal
} from '../../../../utils/routes/modals/modalsActions'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import IconText from '../../../../packages/kiti/components/presentation/IconText'
import Link from '../../../../packages/kiti/components/actions/Link'
import PlacePresenter from '../../../../containers/places/PlacePresenter'

const FormRepliesTable = () => {
  const { t } = useTranslation('listFormReplies')
  const form = useForm()
  const formReplies = useFormReplies()
  const openFormReplyModal = useOpenFormReplyModal()
  const onOpenModal = record => openFormReplyModal({ number: record.number, formId: form.id })

  const canCreateActionPlan = useSessionPermission('createServiceOrder')
  const openCreateServiceOrderModal = useOpenEditServiceOrderModal()
  const openServiceOrdersModal = useOpenFormReplyServiceOrdersModal()

  const columns = [
    {
      label: t('number'),
      headerSideContent: <RefetchingIndicator />,
      dataIndex: 'number',
      sortIndex: 'NUMBER',
      format: number => t('reply', { number }),
      bold: true,
      size: 'h6',
      onClick: (_, record) => onOpenModal(record)
    },
    {
      label: t('place'),
      dataIndex: ['place', 'name'],
      sortIndex: 'PLACE_NAME',
      flex: 3,
      render: (placeName, record) => placeName && <PlacePresenter place={record.place} size="small" hideIcon />
    },
    {
      label: t('actionPlans'),
      dataIndex: 'serviceOrdersCount',
      sortIndex: false,
      render: (count, formReply) => {
        const icon = !canCreateActionPlan || count > 0 ? 'BsListTask' : 'BsFolderPlus'
        const color = count > 0 ? 'primary' : 'dark5'
        const onClick = () =>
          count > 0 || !canCreateActionPlan
            ? openServiceOrdersModal(formReply.id)
            : openCreateServiceOrderModal({ initialState: { formReplyId: formReply.id } })

        return <IconText label={count} bold color={color} iconLeft={icon} onClick={onClick} />
      }
    },
    {
      label: t('date'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      format: formatDate('DD/MM/YYYY - HH:mm')
    },
    {
      label: t('actions'),
      maxWidth: 12,
      render: (_, record) => (
        <Link onClick={() => onOpenModal(record)}>
          <IconText iconRight="BsArrowRightShort" label={t('viewReply')} color="primary" />
        </Link>
      )
    }
  ]

  return <DataTable data={formReplies} columns={columns} inPanel />
}

export default FormRepliesTable
